import { and, eq, type InitialQueryBuilder, isNull, type Ref } from "@tanstack/db";

import type { WsBroadcastAction } from "@storyboard/web-client";
import { store } from "@/store/store";
import type { BroadcastAction } from "@/store/types";

export async function bulkUpsertBroadcastAction(records: WsBroadcastAction[]) {
  if (records.length === 0) return;
  const data = records.map(
    (r): BroadcastAction => ({
      id: r.id,
      workspaceId: r.workspaceId,
      workflowItemId: r.workflowItemId,
      broadcastId: r.broadcastId,
      createdAt: r.createdAt ?? null,
      updatedAt: r.updatedAt ?? null,
    }),
  );
  store.upsert("broadcastAction", data);
}

export const broadcastActionsQuery = (workspaceId: string) => (q: InitialQueryBuilder) =>
  q
    .from({ action: store.collection("broadcastAction") })
    .innerJoin({ workflowItem: store.collection("workflowItem") }, ({ action, workflowItem }) =>
      eq(action.workflowItemId, workflowItem.id),
    )
    .where(({ workflowItem }) => and(eq(workflowItem.workspaceId, workspaceId), isNull(workflowItem.deletedAt)))
    // TanStack DB 0.12 types a whole-source select as `T | { [K]?: never }`; the annotation keeps the row type `T`.
    .select(({ action }): Ref<BroadcastAction> => action);
